import {makeGet, makePost, makePut} from '../make';

export interface IKey {
  Year: number,
  Month: number,
  Day: number,
}

// IKeyMethods

function iKeyAsc(k1: IKey, k2: IKey): number {
  // -1 for k1 < k2
  // 0 for k1 == k2
  // 1 for k1 > k2
  if (k1.Year < k2.Year) {
    return -1;
  }
  if (k1.Year > k2.Year) {
    return 1;
  }
  if (k1.Month < k2.Month) {
    return -1;
  }
  if (k1.Month > k2.Month) {
    return 1;
  }
  if (k1.Day < k2.Day) {
    return -1;
  }
  if (k1.Day > k2.Day) {
    return 1;
  }
  return 0;
}

export const IKeyMethods = {
  asString(key: IKey): string {
    return key.Year.toString().padStart(4, '0') +
      key.Month.toString().padStart(2, '0') +
      key.Day.toString().padStart(2, '0');
  },
  asStrings(key: IKey): [string, string, string] {
    return [
      key.Year.toString().padStart(4, '0'),
      key.Month.toString().padStart(2, '0'),
      key.Day.toString().padStart(2, '0'),
    ];
  },
  asNumber(key: IKey): number {
    return key.Year * 100 * 100 + key.Month * 100 + key.Day;
  },
  equal(k1: IKey, k2: IKey): boolean {
    return k1.Year === k2.Year && k1.Month === k2.Month && k1.Day === k2.Day;
  },
  asc: iKeyAsc, // avoid use **this**, this is undefined, see https://blog.csdn.net/a1059526327/article/details/104327176
  desc(k1: IKey, k2: IKey): number {
    return -1 * iKeyAsc(k1, k2);
  },
  gt: (k1: IKey, k2: IKey): boolean => iKeyAsc(k1, k2) === 1,
};

export interface IDiary {
  Key: IKey,
  Revision: number,
  Components?: Record<string, IComponent>,
}


export interface IComponent {
  Version: number,
  Content: string, // json string
}

export const apis = {
  listDiaies: makeGet<undefined, IDiary[]>('/diaries/diaries'),
  getDiary: async (key: IKey) => {
    return makeGet<any, IDiary>(`/diaries/diary/${IKeyMethods.asString(key)}`)({
      WithComponents: true,
    });
  },
  setDiary: async (diary: IDiary) => {
    return makePut<any, any>(`/diaries/diary/${IKeyMethods.asString(diary.Key)}`)({
      Revision: diary.Revision,
      Components: diary.Components,
    });
  },
  setComponent: async (key: IKey, revision: number, kind: string, version: number, content: object) => {
    return makePut<any, any>(`/diaries/diary/${IKeyMethods.asString(key)}/${kind}`)({
      Revision: revision,
      Version: version,
      Component: JSON.stringify(content),
    });
  },
  searchComponent: async (kind: string, arg: object) => {
    return makePost<any, IKey[] | null>(`/diaries/search/component/${kind}`)({
      SearchArg: arg,
    });
  },
};
